<template>
    <div class="static-heaer" style="margin-bottom: 20px">
        <div class="item-header2">
            <p style="font-size: 1.3rem; line-height: 2.3rem; margin-top: 20px; padding: 0 10px; text-align: justify" data-aos="zoom-in">Por tal motivo, profesionales de salud con expertiz en este tema, nos hemos reunido para ofrecerles un curso que dé respuesta a esta necesidad, de manera práctica, efectiva y aplicable para que sus habilidades profesionales entren en esta nueva revolución industrial de forma amigable para todos.<br><br>
                <span style="font-weight: 600; color: #4752C8; font-size: 2rem; text-align: center"><span>Les presentamos el curso Telemedicina A UN CLICK</span></span><br><br>
                Es un curso de 19 videos, 16 clases magistrales, y 3 sesiones de acompañamiento en vivo, les enseñamos a los profesionales de salud a aplicar las herramientas de Telemedicina según su área de trabajo de forma sencilla, practica, ética y efectiva, a fin de poder dar asistencia oportuna a los pacientes que requieran de su expertiz sin limitación de distancia, tiempo o restricciones de horas. Una herramienta estratégica para la salud durante y después de la pandemia.
                <br ><span style="color: #5E72E4; font-weight: 700">El precio sólo para esta cohorte es de apenas:<strong style="font-size: 1.8rem">247 dólares.</strong></span>
            </p>

            <div style="display: flex; justify-content: center; margin-top: 10px; text-align: center; flex-direction: column; align-items: center; z-index: 2; margin-bottom: 20px">
                <router-link tag="div" to="/pro/Telemedicina/oferta" style="width: 260px; height: 90px; background-color: #FF4500; border: solid 1px white; border-radius: 10px; color: white; font-weight: 700;  cursor: pointer; font-size: 1.5rem; align-items: center; display: flex; justify-content: center">INSCRIBETE ÁQUI!</router-link>
            </div>

        </div>
        <div class="item-header">
            <div style="font-size: 1.6rem; font-weight: 800; margin-bottom: 5px">FACILITADORES:</div>
            <div class="profesor-image">
                <div style="width: 20%">
                    <img src="/image/profile/telemedicina-03.png" width="100%"/>
                </div>
                <div class="text-profesor">
                    <span style="font-size: 1.5rem; font-weight: 800">Dra. Omidres Pérez de Carvelli</span><br>
                    Médico cirujano especialista en medicina interna, endocrinología y metabolismo, coach en salud y bienestar, conferencista, diplomado en docencia, investigadora, escritora, emprendedora digital
                </div>
            </div>
            <div class="profesor-image">
                <div style="width: 20%">
                    <img src="/image/profile/telemedicina-04.png" width="100%"/>
                </div>
                <div class="text-profesor">
                    <span style="font-size: 1.5rem; font-weight: 800">Dr. Miguel José Guevara H. </span><br>
                    Médico Cirujano, Especialista en Gerencia de Salud y Desarrollo Humano, <span style="font-weight: 800">Magister en Terapia de la Conducta</span>, diplomado en Gerencia Moderna de Salud, Coaching Neurointegrativo, Habilidades Gerenciales, Componente Docente en Entornos Virtuales, Salud Ocupacional.
                </div>

            </div>
            <div class="profesor-image">
                <div style="width: 20%">
                    <img src="/image/profile/telemedicina-05.png" width="100%"/>
                </div>
                <div class="text-profesor">
                    <span style="font-size: 1.5rem; font-weight: 800">Dra. Erika Herrera</span><br>
                    Odontóloga, Especialista en Ortodoncia, Maestría en Marketing y Ventas, Miembro Fundador del Club de Marketing Global, Especialista en Marketing y ventas para servicios de salud. Escritora best seller en Amazon.
                </div>
            </div>
            <div class="profesor-image">
                <div style="width: 20%">
                    <img src="/image/profile/nelson.png" width="100%"/>
                </div>
                <div class="text-profesor">
                    <span style="font-size: 1.5rem; font-weight: 800">TSU Nelson Bastardo</span><br>
                    Senior web developer -  ux/ui designer<br>
                    Emprendedor digital, fundador y creador de
                    AMOBAMEDIC
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import formLanding from './../resources/formLandingEvent.vue'
    export default {
        name: '',
        components: {
            formLanding
        },
        created(){

        },
        data(){
            return {
                showModal: false
            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style scoped>

    .profesor-image{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        margin: 20px 0;
    }
    .text-profesor{
        font-size: 1rem; width: 80%
    }
    .static-heaer{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        background-color: #EEF3F9;
        height: auto;
        background-size: cover;
        margin-bottom: 10px;
        overflow-x : hidden;
        overflow-y : hidden
    }
    .item-service{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
    }
    .item{
        width: 50%;
        padding: 15px;
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        justify-content: center;
        text-align: justify;
        color: #191f4d;
    }
    .item p{
        font-size: 1rem
    }
    .item-header{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex-wrap: wrap;
        align-items: flex-start;
        font-size: 1.8rem;
        font-weight: 800;
        padding: 40px;
        text-align: center;
        margin-top: -10px;
        background-color: #DBE6F2;
    }
    .item-header2{
        flex: 1;
        display: flex;
        flex-direction: column;
        font-weight: 700;
        justify-content: flex-start;
        line-height: 2.7rem;
        text-align: center;
        padding: 0 15px;
        margin-top: 30px;
    }
    .b-title{
        font-size: 8rem;
        line-height: 7rem;
        font-weight: 800
    }
    .b-title2{
        font-size: 3rem;
        font-weight: 800
    }
    @media (min-width: 1281px) {

    }

    @media (min-width: 1025px) and (max-width: 1280px) {

    }
    @media (min-width: 768px) and (max-width: 1024px) {
        .static-heaer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            background-color: #EEF3F9;
            height: auto;
            background-size: cover;

            overflow-x : hidden;
            overflow-y : hidden
        }
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {

    }

    @media (min-width: 481px) and (max-width: 767px) {
        .static-heaer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            background-color: #EEF3F9;
            height: auto;
            background-size: cover;

            overflow-x : hidden;
            overflow-y : hidden
        }
    }

    @media (min-width: 10px) and (max-width: 480px) {
        .static-heaer{
            display: flex;
            flex-direction: column;
            justify-content: center;
            background-color: #EEF3F9;
            height: auto;
            background-size: cover;

            overflow-x : hidden;
            overflow-y : hidden
        }
        .item-service{
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;

        }
        .item{
            width: 100%;

        }
    }
</style>